class QuizCard {
  constructor(block) {
    this.block = block;
    this.els = {
      question: this.block.querySelector('.quiz_card__heading'),
      visibility_toggle_els: this.block.querySelectorAll('.visibility_toggle_el'), // these elements will toggle visibilty based on active state 
      choiceButtons: this.block.querySelectorAll('.quiz_card__choice-button'),
      closeButton: this.block.querySelector('.quiz_card__close'),
      content: this.block.querySelector('.quiz_card__content'),
      eyebrow: this.block.querySelector('.quiz_card__eyebrow'),
      slider: this.block.closest('.splide')
    }
    this.isAnswered = false;
    this.isCorrect = false;
    this.originalQuestionString = this.els.question.textContent;

    this.setEyebrowText();

    this.els.choiceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        button.blur();
        this.handleChoiceClick(button);
      });
    });

    this.els.closeButton.addEventListener('click', () => {
      this.handleClose();
    });
  }

  setEyebrowText() {
    // Initial Setup
    if(!this.originalEyebrowText){
      const overwriteEl = this.els.eyebrow.querySelector('span');
      if(!overwriteEl){
        const span = document.createElement('span');
        span.textContent = 'Question ' + (this.getSlideIndex() + 1) + ' of ' + this.getTotalSlides();;
        this.els.eyebrow.appendChild(span);
      }
      this.originalEyebrowText = this.els.eyebrow.textContent;
    }
    // When answered incorrectly
    if(this.isAnswered && !this.isCorrect) {
      this.els.eyebrow.textContent = 'INCORRECT';
    }
    else {
      this.els.eyebrow.textContent = this.originalEyebrowText;
    }
  }

  getSlideIndex() {
    if(!this.els.slider) return 0;

    const slides = this.els.slider.querySelectorAll('.quiz_card');
    const currentSlide = Array.from(slides).indexOf(this.block);
    return currentSlide;
  }

  getTotalSlides() {
    if(!this.els.slider) return 1;

    const slides = this.els.slider.querySelectorAll('.quiz_card');
    return slides.length;
  }
  
  handleChoiceClick(button) {
    this.isAnswered = true;
    this.isCorrect = button.parentElement.classList.contains('is-correct');
    this.setHeadingText();
    this.toggleElVisibility();
    this.setEyebrowText();
  }

  handleClose() {
    this.isAnswered = false;
    this.isCorrect = false;
    this.setHeadingText();
    this.toggleElVisibility();
    this.setEyebrowText();
  }

  setHeadingText() {
    if(!this.incorrectHeadingText) {
      this.incorrectHeadingText = this.els.question.getAttribute('data-incorrect') || this.originalQuestionString;
    }

    if(this.isAnswered){
      const originalHeight = this.els.question.offsetHeight;
      this.els.question.textContent = this.isCorrect ? 'Correct!' : this.incorrectHeadingText;
      const newHeight = this.els.question.offsetHeight;
      const difference = originalHeight - newHeight;
      if(difference > 0) {
        this.els.content.style.paddingBottom = `${difference}px`;
      }
    }
    else {
      this.els.content.style.paddingBottom = '';
      this.els.question.textContent = this.originalQuestionString;
    }
  }

  toggleElVisibility() {
    this.els.visibility_toggle_els.forEach((el) => {
      // For answer icons, determine which to show based on the answer state
      if (el.classList.contains('answer-icon')) {
        if(!this.isAnswered){
          console.log('test');
          el.classList.remove('active');
          el.setAttribute('aria-hidden', 'true');
        }
        else if(this.isCorrect && el.classList.contains('correct')) {
          el.classList.add('active');
          el.setAttribute('aria-hidden', 'false');
        }
        else if(!this.isCorrect && el.classList.contains('incorrect')) {
          el.classList.add('active');
          el.setAttribute('aria-hidden', 'false');
        }
      }
      else {
        el.classList.toggle('active');
        if (el.classList.contains('active')) {
          el.setAttribute('aria-hidden', 'false');
        } else {
          el.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }
}

export const InitQuizCard = () => {
  const quizCards = document.querySelectorAll('.quiz_card');
  quizCards.forEach((block) => {
    new QuizCard(block);
  });
}